/**
 * 
 */
import { InstitutionShort } from '@n3/ng-api-common';
import { Organization } from './organization.model';
import { JobShort } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { WorkTime } from '@n3/ng-api-common';
import { Address } from '@n3/ng-api-common';
import { Meal } from '@n3/ng-api-common';
import { Capacity } from '@n3/ng-api-common';
import { InstitutionDocument } from './institutionDocument.model';
import { PublicAdministration } from './publicAdministration.model';
import { InstitutionMeta } from './institutionMeta.model';
export class Institution extends InstitutionShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public organization: Organization; /**/
    public head: JobShort; /**/
    public region: ClassifierShort; /**/
    public shift: ClassifierShort[]; /*Смены*/
    public status_date: string; /*Дата последней смены статуса*/
    public kind: ClassifierShort; /**/
    public terrain: ClassifierShort; /**/
    public work_time: WorkTime[]; /*Время работы*/
    public education_language: ClassifierShort; /**/
    public education_area: Address[]; /*Адреса обслуживаемой территории*/
    public levels: ClassifierShort[]; /*Уровни образования*/
    public meals: Meal[]; /*Питание, доступное в ОО*/
    public implement_education_services: ClassifierShort[]; /*Образовательные услуги по реализации образовательных программ*/
    public ovz_group_types: ClassifierShort[]; /*Типы групп ОВЗ доступные в ОО*/
    public foundation_date: string; /*Дата образования ОО*/
    public description: string; /*Описание ОО*/
    public address: Address; /**/
    public post_address: Address; /**/
    public district: ClassifierShort; /**/
    public jurisdiction: ClassifierShort; /**/
    public capacity: Capacity; /**/
    public documents: InstitutionDocument[]; /*Массив документов для ОО*/
    public public_administration: PublicAdministration; /**/
    public meta: InstitutionMeta; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.organization = new Organization(json.organization);
        this.head = new JobShort(json.head);
        this.region = new ClassifierShort(json.region);
        this.shift = [];
        if (json.shift) {
          for (const i in json.shift) {
            if ( json.shift.hasOwnProperty( i ) ) {
                this.shift.push(new ClassifierShort(json.shift[i]));
            }
          }
        }
        this.status_date = json.status_date || null;
        this.kind = new ClassifierShort(json.kind);
        this.terrain = new ClassifierShort(json.terrain);
        this.work_time = [];
        if (json.work_time) {
          for (const i in json.work_time) {
            if ( json.work_time.hasOwnProperty( i ) ) {
                this.work_time.push(new WorkTime(json.work_time[i]));
            }
          }
        }
        this.education_language = new ClassifierShort(json.education_language);
        this.education_area = [];
        if (json.education_area) {
          for (const i in json.education_area) {
            if ( json.education_area.hasOwnProperty( i ) ) {
                this.education_area.push(new Address(json.education_area[i]));
            }
          }
        }
        this.levels = [];
        if (json.levels) {
          for (const i in json.levels) {
            if ( json.levels.hasOwnProperty( i ) ) {
                this.levels.push(new ClassifierShort(json.levels[i]));
            }
          }
        }
        this.meals = [];
        if (json.meals) {
          for (const i in json.meals) {
            if ( json.meals.hasOwnProperty( i ) ) {
                this.meals.push(new Meal(json.meals[i]));
            }
          }
        }
        this.implement_education_services = [];
        if (json.implement_education_services) {
          for (const i in json.implement_education_services) {
            if ( json.implement_education_services.hasOwnProperty( i ) ) {
                this.implement_education_services.push(new ClassifierShort(json.implement_education_services[i]));
            }
          }
        }
        this.ovz_group_types = [];
        if (json.ovz_group_types) {
          for (const i in json.ovz_group_types) {
            if ( json.ovz_group_types.hasOwnProperty( i ) ) {
                this.ovz_group_types.push(new ClassifierShort(json.ovz_group_types[i]));
            }
          }
        }
        this.foundation_date = json.foundation_date || null;
        this.description = json.description || null;
        this.address = new Address(json.address);
        this.post_address = new Address(json.post_address);
        this.district = new ClassifierShort(json.district);
        this.jurisdiction = new ClassifierShort(json.jurisdiction);
        this.capacity = new Capacity(json.capacity);
        this.documents = [];
        if (json.documents) {
          for (const i in json.documents) {
            if ( json.documents.hasOwnProperty( i ) ) {
                this.documents.push(new InstitutionDocument(json.documents[i]));
            }
          }
        }
        this.public_administration = new PublicAdministration(json.public_administration);
        this.meta = new InstitutionMeta(json.meta);
        this._isEmpty = this.isEmpty(this);
    }
}
